import React from 'react';
import { isOrderRetornoByRequestStatus } from '../utils/retornoStatus';
import './OrderRetornoIcon.css';

/** request_status da view LCMY_ASSTEC02 = status do pedido vinculado (TB02018/TB02021). Usado para comparar com config "Status de pedido vinculado a OS de retorno". */
function getPedidoRequestStatus(ordem) {
  const raw = ordem?.request_status ?? ordem?.REQUEST_STATUS;
  return String(raw ?? '').trim();
}

/**
 * Ícone de retorno (sino) para linhas de OS nas colunas de técnicos.
 * Só renderiza quando os_request_status da ordem é igual ao codstatus "OS de retorno".
 * Se request_status === codstatus "Status de pedido vinculado a OS de retorno", mostra sino animado (pedido liberado).
 * Estilo compacto para não alterar a altura da linha.
 * @param {string[]} [extraRetornoStatuses] - Lista opcional de outros status de retorno (LCMY_REG_CONDITION)
 * @param {Function} [onTooltip] - Se informado, usa tooltip portal: onTooltip({ text, x, y, triggerRect }) / onTooltip(null)
 */
export function OrderRetornoIcon({ ordem, codstatusRetorno, codstatusPedidoVinculadoDisponivel = '', extraRetornoStatuses = [], onTooltip }) {
  if (!isOrderRetornoByRequestStatus(ordem, codstatusRetorno, extraRetornoStatuses)) return null;
  const requestStatusPedido = getPedidoRequestStatus(ordem);
  const codPedidoLiberado = String(codstatusPedidoVinculadoDisponivel ?? '').trim();
  const isPedidoLiberado = codPedidoLiberado !== '' && requestStatusPedido === codPedidoLiberado;
  const title = isPedidoLiberado ? 'Pedido vinculado está liberado!' : 'Retorno';
  const iconClass = isPedidoLiberado
    ? 'bi bi-bell order-retorno-icon order-retorno-icon--pedido-liberado'
    : 'bi bi-bell order-retorno-icon';
  const wrapClass = `order-retorno-icon-wrap order-retorno-icon-wrap--technician${onTooltip ? ' board-cell-tooltip-trigger' : ''}`;
  return (
    <span
      className={wrapClass}
      aria-hidden={!onTooltip}
      title={onTooltip ? undefined : title}
      onMouseEnter={onTooltip ? (e) => {
        const r = e.currentTarget.getBoundingClientRect();
        onTooltip({ text: title, x: r.left + r.width / 2, y: r.bottom - 4, triggerRect: { left: r.left, top: r.top, width: r.width, height: r.height } });
      } : undefined}
      onMouseLeave={onTooltip ? () => onTooltip(null) : undefined}
    >
      <i className={iconClass} aria-label={title} />
    </span>
  );
}
